export default {
  namespaced: true,
  state: {
    imageBaseUrl: "https://api2.inflack.net/",
  },

  actions: {},
};
